export function getIsFavourited(portal, id) {
  const favourites = JSON.parse(localStorage.getItem('dp-favourites') ?? '{}');
  return !!favourites[portal.categoryId]?.charts[id];
}

export function getFavouriteEntry(portal) {
  return {
    rowspan: portal.rowspan,
    colspan: portal.colspan,
  };
}

export function toggleChartFavourite(portal, id, dateRange, refreshFavourites) {
  const favourites = JSON.parse(localStorage.getItem('dp-favourites') ?? '{}');

  if (!favourites[portal.categoryId]) {
    favourites[portal.categoryId] = {
      title: portal.title,
      charts: {},
    };
  }

  favourites[portal.categoryId].title = portal.title;
  favourites[portal.categoryId].dateRange = dateRange;

  if (getIsFavourited(portal, id)) {
    delete favourites[portal.categoryId].charts[id];
  } else {
    favourites[portal.categoryId].charts[id] = getFavouriteEntry(portal);
  }

  let isFavourited = !!favourites[portal.categoryId].charts[id];

  localStorage.setItem('dp-favourites', JSON.stringify(favourites));

  refreshFavourites();

  return isFavourited;
}
